import Page from "ui/Page";
import Dashboard from "../components/Dashboard";


export default function Home() {
	return (
		<Page>
			<Page.Header title="CEO KPI" />
			<Page.Body>
				<Dashboard />
			</Page.Body>
		</Page>
	);
}